<ng-container
  *ngIf="{
    searchItems: searchItems$ | async,
    showProducts: showProducts$ | async,
  } as content"
>
  @if (content.showProducts) {
    @if (!content.searchItems?.isLoading) {
      @if (!content.searchItems?.isPristine) {
        @if (content.searchItems?.products?.length) {
          <h3 class="m-b-12">Products List</h3>

          <ul>
            <li *ngFor="let product of content.searchItems?.products">
              <product-list-item [product]="product"></product-list-item>
            </li>
          </ul>

          @if ((content.searchItems?.pagination?.totalResults ?? 0) > 5) {
            <div class="d-flex justify-content-center m-t-20">
              <cx-custom-pagination
                [pagination]="content.searchItems?.pagination"
                (viewPageEvent)="handlerPage($event)"
              ></cx-custom-pagination>
            </div>
          }
        } @else {
          <p class="ff-bold text-center">
            {{ 'quotes.noContent' | cxTranslate }}
          </p>
          <div class="d-flex justify-content-center">
            <button class="btn-link h5" (click)="handleChangeSearchType(SEARCH_TYPE.ADVANCED)">
              {{ 'quotes.searchByAttributeInfo' | cxTranslate }}
            </button>
          </div>
        }
      }
    } @else {
      <local-loader></local-loader>
    }
  }
</ng-container>
